



















































import Vue from "vue";
import { Component } from "vue-property-decorator";
import { http } from "@/shared/https";
import '@/styles/iucn/main-content.css';
import '@/styles/iucn/side-menu.css';
import '@/styles/iucn/filter.css';

@Component({
  components: {}
})
export default class FilterComponent extends Vue {
  items: any = [];
  mainMenuid: any = null;
  mainMenuList: any = null;
  subMenuId: string = null;
  mainMenuLength: string = null;
  count: number = 0;
  activeSection = "";
  activeSelection = "";
  itemFieldArray: any = [];

  mounted() {
    this.getFilters().then((resp: any) => {
      if (resp.status >= 200 && resp.status < 300) {
        this.items = resp.data.Result;
      }
    });
  }

  getFilters() {
    return http.get(`api/Call/GetHomeFilter`);
  }

  toggleFilters(item) {
    if (this.activeSection === "" || this.activeSection !== item.Field) {
      this.activeSection = item.Field
    } else {
      this.activeSection = "";
    }
  }

  toggleGreenTickIndication(event, itemField) {
    if(event === true) {
      if (this.activeSelection === "" || this.activeSelection !== itemField) {
        this.activeSelection = itemField;
        this.addToArray(this.activeSelection);
        this.activeSelection = "";
      }
    } else {
      this.activeSelection = itemField;
      this.removeFromArray(this.activeSelection);
      this.activeSelection = "";
    }
  }

  addToArray(obj) {
    this.itemFieldArray.push(obj);
  }

  removeFromArray(obj) {
    const index = this.itemFieldArray.indexOf(obj);
    if (index >= -1) {
      this.itemFieldArray.splice(index, 1);
    }
  }

  /* Filter */
  callingParentComponentMethod(checkBoxId, menuId) {
    var self = this;
    var menuCheckBoxId = "";
    if (self.count == 0) {
      self.mainMenuid = menuId + "=" + checkBoxId;
      self.subMenuId = checkBoxId;
      self.count = self.count + 1;
    } else {
      //Checking MainMenu already existing.
      menuCheckBoxId = menuId + "=" + checkBoxId;
      //Checking MainMenu already existing.
      if (self.mainMenuid.indexOf(menuCheckBoxId) >= 0) {
        self.mainMenuid = self.mainMenuid.replace(menuCheckBoxId, "");
      } else {
        self.mainMenuid = self.mainMenuid + "&" + menuCheckBoxId;
      }
      self.mainMenuid = self.mainMenuid.replace("?&", "?");
      self.mainMenuid = self.mainMenuid.replace("&&", "&");
      //Check first charector &
      var firstChar = self.mainMenuid.charAt(0);
      if (firstChar == "&") {
        self.mainMenuid = self.mainMenuid.substring(1);
      }
    }
    var lenghtString = self.mainMenuid.length - 1;
    var lastCharSting = self.mainMenuid.charAt(lenghtString);

    if (lastCharSting == "&") {
      self.mainMenuid = self.mainMenuid.substring(
        0,
        self.mainMenuid.length - 1
      );
    }

    this.$emit("callhomePageLeft", self.mainMenuid);
  }
}
